import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { validateEmail, regexOnlyNumbersUpTo8 } from '../helpers/validations.helper';
import { ContainerApp, ContentApp, FooterApp, HeaderApp, LabelApp } from './Layout.app'
import { Paciente } from './loginApp.types';
import { appStyles } from './app.style';
import { useMiPerfilPaciente } from '../data/hooks/usePacientes.hook';
import { Spinner } from '../components/spinner/Spinner.component';
import { ButtonInApp } from './ButtonInApp.component';
import toast from 'react-hot-toast';
import { api } from '../data/api';
import { DropdownInApp, DropdownOption } from './DropdownInApp.component';

// Lista de provincias argentinas
const provinciasOptions: DropdownOption[] = [
	{ id: 1, label: 'Buenos Aires' },
	{ id: 2, label: 'Catamarca' },
	{ id: 3, label: 'Chaco' },
	{ id: 4, label: 'Chubut' },
	{ id: 5, label: 'Córdoba' },
	{ id: 6, label: 'Corrientes' },
	{ id: 7, label: 'Entre Ríos' },
	{ id: 8, label: 'Formosa' },
	{ id: 9, label: 'Jujuy' },
	{ id: 10, label: 'La Pampa' },
	{ id: 11, label: 'La Rioja' },
	{ id: 12, label: 'Mendoza' },
	{ id: 13, label: 'Misiones' },
	{ id: 14, label: 'Neuquén' },
	{ id: 15, label: 'Río Negro' },
	{ id: 16, label: 'Salta' },
	{ id: 17, label: 'San Juan' },
	{ id: 18, label: 'San Luis' },
	{ id: 19, label: 'Santa Cruz' },
	{ id: 20, label: 'Santa Fe' },
	{ id: 21, label: 'Santiago del Estero' },
	{ id: 22, label: 'Tierra del Fuego' },
	{ id: 23, label: 'Tucumán' }
];

export const provinciasArray = provinciasOptions.map(p => p.label);

export const PerfilApp = () => {
	const { login } = useAuth();
  
	const navigate = useNavigate();
	const [formData, setFormData] = useState<Partial<Paciente & {passconf: string;}>>({
		dni: '',
		nombre: '',
		apellido: '',
		email: '',
		telefono: '',
		prepaga: '',
		afiliadoNro: '',
		direccion: '',
		ciudad: '',
		provincia: undefined,
		codpostal: '',
	})

	const [errors, setErrors] = useState<Record<string, string>>({});

	const { data: paciente, isLoading: isLoadingPaciente } = useMiPerfilPaciente();
	const [isSaving, setIsSaving] = useState(false);

	useEffect(() => {
		if (paciente) {
			setFormData(paciente);
			// Buscar el id de la provincia si existe un valor
			// const provinciaId = paciente.provincia 
			// 	? provinciasOptions.find(p => p.label === paciente.provincia)?.id 
			// 	: undefined;
			// setFormData({...paciente, provinciaId});
		}
	}, [paciente]);

	const handleInputChange = (field: string, value: string) => {
		setFormData({...formData, [field]: value});
		console.log("### formData", field, formData);
		// Limpiar errores al escribir
		if (errors[field]) {
			setErrors({...errors, [field]: ''});
		}
	}

	const handleInputBlur = (field: string, value: string) => {
		// Validaciones personalizadas que se muestran como validaciones nativas
		const input = document.querySelector(`[name="${field}"]`) as HTMLInputElement;
		if (!input) return;

		let customMessage = '';
		
		switch (field) {
			case 'Obra Social / Prepaga':
				if (!value || value.length < 2) customMessage = 'El nombre de la obra social o prepaga debe tener al menos 2 caracteres';
				break;
			case 'Nro de Afiliado':
				if (!value || value.length < 4) customMessage = 'El nro de Afiliado debe tener al menos 4 numeros';
				break;
			case 'email':
				if (!value || !validateEmail(value)) customMessage = 'Ingrese un email válido';
				break;
			case 'direccion':
				if (!value || value.length < 4 ) customMessage = 'La direccion debe tener al menos 4 caracteres';
				break;
			case 'ciudad':
				if (!value || value.length < 4 ) customMessage = 'La ciudad debe tener al menos 4 caracteres';
				break;
			case 'provincia':
				if (!value || value.length < 4 ) customMessage = 'La provincia debe tener al menos 4 caracteres';
				break;
			case 'codpostal':
				if (!value || value.length < 4 ) customMessage = 'El codigo postal debe tener al menos 4 numeros';
				break;
		}
		
		input.setCustomValidity(customMessage);
	}

	const handleSubmit = async (e?: React.FormEvent) => {
		e?.preventDefault();

		try {
			setIsSaving(true); console.log("### formData", formData);
			await api.post('/api/pacientes/update', formData);
			toast.success('Perfil actualizado correctamente');
			navigate('/app/menu');
		} catch (error) {
			console.error("### error", error);
			toast.error('Error actualizando perfil');
		} finally {
			setIsSaving(false);
		}
	}

	if (isLoadingPaciente || isSaving) return <Spinner />

	return (
		<ContainerApp>
			<HeaderApp title="Perfil" />
			<ContentApp>
				<p>
					DNI: {paciente?.dni || ''}
				</p>
				<p>
					Nombre: {paciente?.nombre || ''}
				</p>
				<p>
					Apellido: {paciente?.apellido || ''}
				</p>
				<LabelApp label="Teléfono" />
				<input 
					type="text" 
					placeholder="Teléfono" 
					value={formData.telefono}
					onChange={(e) => handleInputChange('telefono', e.target.value)}
					onBlur={(e) => handleInputBlur('telefono', e.target.value)}
					style={appStyles.input} 
				/>
				<LabelApp label="Obra Social y Plan" />
				<input 
					type="text" 
					placeholder="Obra Social y Plan" 
					value={formData.prepaga}
					onChange={(e) => handleInputChange('prepaga', e.target.value)}
					onBlur={(e) => handleInputBlur('prepaga', e.target.value)}
					style={appStyles.input} 
				/>
				<LabelApp label="Nro de Afiliado" />
				<input 
					type="text" 
					placeholder="Nro de Afiliado" 
					value={formData.afiliadoNro}
					onChange={(e) => handleInputChange('afiliadoNro', e.target.value)}
					onBlur={(e) => handleInputBlur('afiliadoNro', e.target.value)}
					style={appStyles.input} 
				/>
				<LabelApp label="Dirección" />
				<input 
					type="text" 
					placeholder="Dirección" 
					value={formData.direccion}
					onChange={(e) => handleInputChange('direccion', e.target.value)}
					onBlur={(e) => handleInputBlur('direccion', e.target.value)}
					style={appStyles.input} 
				/>
				<LabelApp label="Ciudad" />
				<input 
					type="text" 
					placeholder="Ciudad" 
					value={formData.ciudad}
					onChange={(e) => handleInputChange('ciudad', e.target.value)}
					onBlur={(e) => handleInputBlur('ciudad', e.target.value)}
					style={appStyles.input} 
				/>
				<LabelApp label="Provincia" />
				<DropdownInApp
					options={provinciasOptions}
					value={formData.provincia}
					onChange={(id) => {
						const provinciaNombre = provinciasOptions.find(p => p.id === id)?.label || '';
						setFormData({...formData, provincia: id});
					}}
				/>
				<LabelApp label="Código Postal" />
				<input 
					type="text" 
					placeholder="Codigo Postal" 
					value={formData.codpostal}
					onChange={(e) => handleInputChange('codpostal', e.target.value)}
					onBlur={(e) => handleInputBlur('codpostal', e.target.value)}
					style={appStyles.input} 
				/>
			</ContentApp>
			<FooterApp>
				<ButtonInApp 
					label="Atrás"
					onClick={() => navigate('/app/menu')}
					type="button" 
				/>
				<ButtonInApp 
					label="Guardar"
					onClick={handleSubmit}
					type="button" 
				/>
			</FooterApp>
		</ContainerApp>
	)
}